import { memo } from 'react'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'

/**
 * UserDetailHeader - Header with navigation and action buttons
 * Shows edit/delete for viewing mode, save/cancel for editing mode
 */
const UserDetailHeader = memo(function UserDetailHeader({
  isEditMode,
  editing,
  onBack,
  onEdit,
  onDelete,
  onSave,
  onCancel,
  t
}) {
  return (
    <div className="mb-6">
      <button
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeftIcon className="h-5 w-5 mr-2" />
        {t('admin.backToCollection')}
      </button>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">
            {isEditMode ? 'User Details' : 'Create New User'}
          </h1>
          <p className="text-gray-500 mt-1">
            {isEditMode ? 'Manage user account and permissions' : 'Add a new user to the system'}
          </p>
        </div>
        <div className="flex gap-2">
          {!editing && isEditMode ? (
            <>
              <button
                onClick={onEdit}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-600"
              >
                Edit
              </button>
              <button
                onClick={onDelete}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Delete
              </button>
            </>
          ) : editing && (
            <>
              <button
                onClick={onCancel}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={onSave}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-600"
              >
                {isEditMode ? 'Save Changes' : 'Create User'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
})

export default UserDetailHeader
